/**
 * Fallback source for the minimum-notice hours used by self-schedule
 * calendars when the wizard has no interview plan to read it off
 * (adhoc / bulk-self-schedule). Normal self-schedule keeps reading the
 * plan response — this fetch only fires when the plan path is empty.
 *
 * GET /ats_schedules/settings
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

export interface AccountMinimumNotice {
  minimum_notice_enabled?: boolean;
  minimum_notice_config?: { value: number; type: 'hours' | 'days' };
}

interface AccountMinimumNoticeEnvelope {
  data?: AccountMinimumNotice;
}

export const accountMinimumNoticeQueryKey = [
  'schedule-interview',
  'account-minimum-notice',
] as const;

export function useAccountMinimumNotice(options?: {
  enabled?: boolean;
}): UseQueryResult<AccountMinimumNotice, Error> {
  return useQuery({
    queryKey: accountMinimumNoticeQueryKey,
    queryFn: async () => {
      const res = await http.get<AccountMinimumNoticeEnvelope>(
        '/ats_schedules/settings'
      );
      return (res?.data ?? {}) as AccountMinimumNotice;
    },
    staleTime: 5 * 60 * 1000,
    enabled: options?.enabled ?? true,
  });
}
